module.exports = __webpack_public_path__ + "static/supplierbg3_mobile-bafe7e25dcf2ab89cd7b5bbbda70cf51.png";